import { render, staticRenderFns } from "./ImagePreviewBoxComponent.vue?vue&type=template&id=74f583f9&scoped=true"
import script from "./ImagePreviewBoxComponent.vue?vue&type=script&lang=js"
export * from "./ImagePreviewBoxComponent.vue?vue&type=script&lang=js"
import style0 from "./ImagePreviewBoxComponent.vue?vue&type=style&index=0&id=74f583f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f583f9",
  null
  
)

export default component.exports